import { StyleSheet, css } from 'aphrodite';
import { images } from '../constants';

const AboutUs = () => {
  return (
    <div className={css(styles.wrapper)} id="about">
      <div className={css(styles.content)}>
        <h1 className={css(styles.title)}>Our Story</h1>
        <div className={css(styles.line)} />
        <p className={css(styles.text)}>
          Fortress Restaurant was born from a vision rooted in excellence and
          heritage. Founded by Mr. and Mrs. Maphanga, the brand evolved from{' '}
          <b>The Chairman Fortaleza de Sol</b>, a symbol of luxury, innovation,
          and culinary artistry. Reimagined as <b>Fortress</b>, it continues to
          celebrate timeless elegance — blending modern dining sophistication
          with the legacy of The Chairman’s passion for craftsmanship, service,
          and unforgettable experiences.
        </p>
      </div>

      <div className={css(styles.images)}>
        <div className={css(styles.card)}>
          <img
            src={images.mrMaphanga}
            alt="Mr Maphanga"
            className={css(styles.image)}
          />
          <p className={css(styles.caption)}>Mr. Maphanga</p>
        </div>

        <div className={css(styles.card)}>
          <img
            src={images.mrsMaphanga}
            alt="Mrs Maphanga"
            className={css(styles.image)}
          />
          <p className={css(styles.caption)}>Mrs. Maphanga</p>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;

// --------------------------- STYLES ---------------------------
const styles = StyleSheet.create({
  wrapper: {
    backgroundColor: 'var(--color-black)',
    padding: '6rem 2rem',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  content: {
    maxWidth: '800px',
    marginBottom: '4rem',
  },

  title: {
    fontFamily: 'var(--font-base)',
    color: 'var(--color-golden)',
    fontSize: '56px',
    lineHeight: '72px',
    marginBottom: '1rem',
    '@media (max-width: 650px)': {
      fontSize: '36px',
      lineHeight: '48px',
    },
  },

  line: {
    width: '60px',
    height: '3px',
    backgroundColor: 'var(--color-golden)',
    margin: '0 auto 2rem auto',
  },

  text: {
    fontFamily: 'var(--font-alt)',
    color: 'var(--color-white)',
    lineHeight: '1.8',
    fontSize: '18px',
    '@media (max-width: 650px)': {
      fontSize: '15px',
    },
  },

  images: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '3rem',
    flexWrap: 'wrap',
  },

  card: {
    textAlign: 'center',
    maxWidth: '250px',
  },

  image: {
    width: '100%',
    height: 'auto',
    borderRadius: '12px',
    boxShadow: '0 0 20px rgba(0,0,0,0.4)',
    marginBottom: '1rem',
    transition: 'transform 0.3s ease',
    ':hover': { transform: 'scale(1.03)' },
  },

  caption: {
    fontFamily: 'var(--font-base)',
    color: 'var(--color-golden)',
    fontSize: '18px',
  },
});
